import { Outlet } from "@tanstack/react-router";
import { createFileRoute } from "@tanstack/react-router";
import { ProtectedLayout } from "@/components/layout/protected";

import Background from "@/assets/images/authentication/background.jpg";

export const Route = createFileRoute("/oauth/_layout")({
  component: RouteLayout,
});

function RouteLayout() {
  return (
    <ProtectedLayout mode="oauth">
      <main className="grid grid-cols-2">
        <section className="px-8 py-16 flex flex-col items-center justify-center">
          <div className="max-w-md w-full">
            <Outlet />
          </div>
        </section>
        <section className="h-[100dvh] sticky top-0 px-4 py-4">
          <img src={Background} alt="Background" className="h-full w-full object-contain" />
        </section>
      </main>
    </ProtectedLayout>
  );
}
